import { Button, ButtonProps } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = ButtonProps & {
  onClick?: () => void
  disabled?: boolean
  labelTranslationKey?: string
  labelDefaultValue?: string
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  size?: 'small' | 'medium' | 'large'
  children?: React.ReactElement<any>
  variant?: 'text' | 'outlined' | 'contained'
  removeMargin?: boolean
}

export const CancelButton = (props: Props) => {
  const { t } = useTranslation()

  const {
    onClick,
    disabled,
    labelTranslationKey,
    labelDefaultValue,
    color,
    size,
    children,
    variant,
    removeMargin,
    ...other
  } = props

  return (
    <Button
      {...other}
      type="reset"
      color={color || 'secondary'}
      variant={variant || 'outlined'}
      onClick={onClick}
      disabled={disabled}
      size={size}
      style={{ marginRight: !removeMargin ? '.5em' : '0' }}
    >
      {props.children ||
        t(
          labelTranslationKey ?? 'common:cancel',
          labelDefaultValue ?? 'cencel',
        )}
    </Button>
  )
}
